import React from "react"
import Layout from "../components/layout"
import { graphql } from "gatsby"
import ModelingComponent from "../components/modeling/modeling.component"

const Modeling = () => {
  return (
    <Layout>
      <ModelingComponent />
    </Layout>
  )
}

export default Modeling

export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
